import { withAssetPrefix } from "gatsby-link";
import React from "react";
import type { PossibleFilename } from "../../plugins/gatsby-source-flows/gatsby-node";

const companyLogos = [
  "3m",
  "7eleven",
  "24hourfitness",
  "2020companies",
  "aaa",
  "abercrombie",
  "abffreight",
  "ace",
  "aduiepyle",
  "albertsons",
  "aldi",
  "amazon",
  "americanairlines",
  "americaneagle",
  "applebees",
  "arbys",
  "att",
  "autozone",
  "barnesandnoble",
  "bassproshops",
  "bestbuy",
  "biglots",
  "bjs",
  "bobevans",
  "buckle",
  "budweiser",
  "buffalowildwings",
  "burgerking",
  "burlington",
  "carlsjr",
  "carters",
  "chickfila",
  "childrensplace",
  "chilies",
  "chipotle",
  "cocacola",
  "columbia",
  "costco",
  "crackerbarrel",
  "crossmark",
  "csx",
  "cvs",
  "dairyqueen",
  "deckers",
  "delta",
  "dennys",
  "dhl",
  "dickssportinggoods",
  "dillards",
  "dollargeneral",
  "dollartree",
  "dominos",
  "dunkin",
  "express",
  "exxon",
  "familydollar",
  "fedex",
  "fivebelow",
  "fiveguys",
  "foodlion",
  "footlocker",
  "forever21",
  "fossil",
  "fritolay",
  "gamestop",
  "gap",
  "generalmotors",
  "gianteagle",
  "goldencorral",
  "goodwill",
  "hardees",
  "hdsupply",
  "heb",
  "hilton",
  "hobbylobby",
  "holidayinn",
  "ihop",
  "jackinthebox",
  "jcpenny",
  "jetblue",
  "jpmorgan",
  "kellyservices",
  "kfc",
  "kirklands",
  "kmart",
  "kohls",
  "krispykreme",
  "kroger",
  "littlecaesars",
  "littleceasers",
  "longhorn",
  "lowes",
  "lululemon",
  "macys",
  "manpower",
  "mariott",
  "marshalls",
  "massageenvy",
  "mcdonalds",
  "mckesson",
  "menards",
  "michaelkors",
  "michaels",
  "mistercarwash",
  "neimanmarcus",
  "nike",
  "nordstrom",
  "officedepot",
  "oldnavy",
  "olivegarden",
  "oreillyautoparts",
  "outback",
  "pandaexpress",
  "panera",
  "papajohns",
  "peiwei",
  "penske",
  "pepsi",
  "petco",
  "petsense",
  "pfchangs",
  "pizzahut",
  "pnc",
  "popeyes",
  "quiznos",
  "raisingcanes",
  "ralphlauren",
  "redlobster",
  "riteaid",
  "ross",
  "rubytuesday",
  "samsclub",
  "savealot",
  "sears",
  "shamrockfoods",
  "shell",
  "sheraton",
  "sherwinwilliams",
  "shopko",
  "shoprite",
  "sketcher",
  "skywest",
  "sodexo",
  "sonic",
  "southwest",
  "speedway",
  "staffmark",
  "staples",
  "starbucks",
  "steaknshake",
  "subway",
  "tacobell",
  "texasroadhouse",
  "tgifridays",
  "thecheesecakefactory",
  "TheHomeDepot",
  "tiffany",
  "timhortons",
  "tkmaxx",
  "toysrus",
  "tractorsupply",
  "traderjoes",
  "truevalue",
  "tysonfood",
  "uhaul",
  "unionpacificrailroad",
  "ups",
  "urbanoutfitters",
  "usps",
  "verizon",
  "victoriassecret",
  "wafflehouse",
  "walgreens",
  "walmart",
  "wastemanagement",
  "wawa",
  "wegmans",
  "wendys",
  "whataburger",
  "wholefoods",
  "winco",
  "zoeskitchen",
];

function getSlugifiedPosition(position?: string) {
  return position?.replace(/ /g, "").toLowerCase();
}
export function getCompanyLogo(
  pathname: Location["pathname"],
  position?: string,
  templateFileName?: PossibleFilename
) {
  if (templateFileName === "GoogleAds1" || !pathname.startsWith("/path"))
    return;
  const slugifiedPosition = getSlugifiedPosition(position);
  if (slugifiedPosition && companyLogos.includes(slugifiedPosition)) {
    return position;
  }
}

export default function CompanyLogo({ position }: { position: string }) {
  const slugifiedPosition = getSlugifiedPosition(position);
  return (
    <img
      className="h-[3rem]"
      src={withAssetPrefix(`/company-logos/${slugifiedPosition}.svg`)}
      alt={`${position} logo`}
    />
  );
}
